import React, { useEffect, useState } from 'react';

import { useAppSelector } from 'state/hooks';
import { selectProject } from 'state/workflowSlice';

import { useInViewport } from 'features/common/hooks/useInViewport';
import HexSpinner from 'features/spinner/HexSpinner';

import styles from './common.module.css';

const IMG_SIZE = 109;

type SegmentSvgType = 'scenario' | 'route';

export const SegmentSvg = React.memo(
  ({
    type,
    id,
    size = IMG_SIZE,
  }: {
    type: SegmentSvgType;
    id: string;
    size?: number;
  }) => {
    const project_slug = useAppSelector(selectProject);
    const [loaded, setLoaded] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);

    const { ref, visible } = useInViewport<HTMLDivElement>();

    const urlByType: Record<SegmentSvgType, string> = {
      scenario: `/server/detours/scenarios/${project_slug}/${id}/svg.svg`,
      route: `/server/${project_slug}/saved_routes/${id}/svg.svg`,
    };
    const url = urlByType[type];

    useEffect(() => {
      setShowSpinner(false);
      const timer = setTimeout(() => {
        setShowSpinner(true);
      }, 100); // delay spinner

      return () => clearTimeout(timer);
    }, [url]);

    const handleLoad = () => {
      setLoaded(true);
      setShowSpinner(false);
    };

    return (
      <div
        ref={ref}
        className={styles.svg_container}
        style={{ width: size, height: size, minWidth: size }}
      >
        {!loaded && showSpinner && <HexSpinner size={20} />}
        {visible && (
          <img
            src={url}
            width={size}
            height={size}
            alt={`${type} preview`}
            onLoad={handleLoad}
            onError={handleLoad}
            style={{
              opacity: loaded ? 1 : 0,
              transition: 'opacity 150ms ease',
              display: loaded ? 'block' : 'none',
            }}
          />
        )}
      </div>
    );
  },
);
